"use client";

/**
 * NewForm DS hover icon — a video camera for "creative": filming the ad.
 * On hover the whole camera peers to the side, the gesture of panning a
 * shot rather than the glyph twitching.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function VideoCameraIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-peer" style={{ transformOrigin: "50% 50%" }}>
        <rect x="3" y="7.4" width="12" height="9.2" rx="2.2" />
        <path d="m15 11 5.6-2.6v7.2L15 13" />
        <circle cx="6.6" cy="10.4" r="0.35" fill="currentColor" />
      </g>
    </HoverIconSvg>
  );
}
